import { render, staticRenderFns } from "./ReturnToElement.vue?vue&type=template&id=6c20d86a"
import script from "./ReturnToElement.vue?vue&type=script&lang=js"
export * from "./ReturnToElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports